import { EngineColorValue } from './recipe-types';

// engine color recipe
export class EngineColorRecipeModel {

  tintColor?: EngineColorValue[] | false;
  saturation?: EngineColorValue | false;
  contrast?: EngineColorValue | false;
  brightness?: EngineColorValue | false;
  opacity?: EngineColorValue | false;

  static isFresnel (value: any): boolean {
    return Array.isArray(value) && value.length === 5;
  }

  static isColor (value: any): boolean {
    return Array.isArray(value) && value.length === 3;
  }

  constructor(value: EngineColorRecipeModel = {}) {
    const { tintColor, saturation, contrast, brightness, opacity } = value;
    this.tintColor = tintColor;
    this.saturation = saturation;
    this.contrast = contrast;
    this.brightness = brightness;
    this.opacity = opacity;
  }
}
